import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import "../index.css"

import { Button, DropDownField } from '../../../../helpers'
import { Dialog } from 'primereact/dialog'

import { sortArrayOfObjectsInAlphabeticalOrder } from '../../../../utils'

const gstinStatuses = [1,2, 20, 21, 22]

const GSTINsStatusChange = (props) => {

    const { visibleGSTINStatusChange } = props

    const [gstinStatus, setGSTINStatus] = useState(null)

    let statuses = useSelector(state => state.common.status)
    statuses = sortArrayOfObjectsInAlphabeticalOrder(statuses, "status")

    const handleGSTINStatusChange = (event) => {
		setGSTINStatus(event.value)
	}

    let relatedGSTINStatuses = statuses.filter(eachStatus => gstinStatuses.includes(eachStatus.statusId))
    
    return (
        <div>
            <Dialog visible={visibleGSTINStatusChange} onHide={() => {props.handleCloseGSTINStatusChange(); setGSTINStatus(null)}} header="Change Status" style={{ width: "20vw" }} >
                <div>
                    <DropDownField name="gstinStatus" placeholder={"Please Select"} options={relatedGSTINStatuses} optionLabel="status" optionValue="status" value={gstinStatus} onChange={handleGSTINStatusChange} />
                    <div className='flex justify-content-end mt-2'>
                        <Button label="Save" className="small-btn" onClick={() => { props.saveStatusChange(gstinStatus) ; setGSTINStatus(null) }} />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default GSTINsStatusChange